export const MOCK_ADDRESS = {
  _id: 'L6sB14Iori1DB0PodxizK',
  _tags: ['billing', 'delivery'],
  additional_info: 'Penthouse',
  city: 'Köln',
  country: 'DE',
  full_address: 'Adolf-Fischer-Str. 2, Penthouse, 50670 Köln, DE',
  id: '4ci2bne',
  postal_code: '50670',
  street: 'Adolf-Fischer-Str.',
  street_number: '2'
}
